import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "../../../../components/Form/TextField";
import Typography from "@mui/material/Typography";
import CardContainer from "../../../../components/Card/CardContainer";
import Button from "../../../../components/Buttons/Button";
import {
  INPUT_COLOR_BORDER,
  BOX_SHADOW_FIELDS,
} from "../../../../utils/colors";
import { BORDER_RADIUS } from "../../../../utils/constants";
import {
  WEBSITE_URL_PLACEHOLDER,
  I_DONT_HAVE_A_WEBSITE,
  CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER,
  SET_UP_BRAND,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import { useBrandSetupReadOnly } from "../context/brandSetupReadOnlyContext";

export const UrlSection = ({
  formMethods,
  onReExtract = () => {},
  isReExtracting = false,
  isExtracted = false,
  isExtracting = false,
  onNotHaveWebsite = () => {},
}) => {
  const [editableUrl, setEditableUrl] = useState("");
  const { t } = useTranslationApp();
  const readOnly = useBrandSetupReadOnly();

  const websiteUrl = formMethods?.watch?.("websiteUrl") || "";
  const { control, errors, setValue, validationRules } = formMethods;

  // Sincronizar estado cuando cambie el valor del formulario
  useEffect(() => {
    if (websiteUrl && websiteUrl !== editableUrl) {
      setEditableUrl(websiteUrl);
    }
  }, [websiteUrl, editableUrl]);

  useEffect(() => {
    if (formMethods?.control) {
      if (websiteUrl) setEditableUrl(websiteUrl);
    }
  }, [formMethods?.control, websiteUrl]);

  const sxTextField = {
    "& .MuiInputBase-root": {
      backgroundColor: "fields.background",
      borderRadius: BORDER_RADIUS,
      color: "#000 !important",
      border: `1px solid ${INPUT_COLOR_BORDER}`,
      boxShadow: BOX_SHADOW_FIELDS,
      "& input, & textarea": {
        color: "#000 !important",
      },
    },
  };

  if (!formMethods || !formMethods.control) {
    return null;
  }

  return (
    <CardContainer title="">
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          variant="h2"
          sx={{
            color: "text.primary",
            fontWeight: 500,
            fontSize: "1.5rem",
          }}
        >
          {t(WEBSITE_URL_PLACEHOLDER)}
        </Typography>
        <TextField
          control={control}
          name="websiteUrl"
          value={editableUrl}
          actionsChange={(value) => {
            setEditableUrl(value);
            setValue("websiteUrl", value);
          }}
          rules={validationRules.websiteUrl}
          errors={errors}
          placeholder={t(CREATE_CAMPAIGN_TRAFFIC_LINK_PLACEHOLDER)}
          variant="outlined"
          fullWidth
          disabled={readOnly}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "0.875rem",
              height: "36px",
            },
            ...sxTextField,
          }}
        />
        {!readOnly && (
          <Button
            type="button"
            color="primary"
            fullWidth
            onClick={() => onReExtract(editableUrl || websiteUrl)}
            loading={isReExtracting || isExtracting}
            disabled={!(editableUrl || websiteUrl)}
            sx={{ borderRadius: 1.5, py: 1.5 }}
          >
            {t(SET_UP_BRAND)}
          </Button>
        )}
        {!readOnly && !isExtracted && (
          <Typography
            variant="body2"
            sx={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "text.secondary",
              width: "fit-content",
              pl: 0.5,
              mt: 0.5,
              "&:hover": { color: "text.primary" },
            }}
            onClick={onNotHaveWebsite}
          >
            {t(I_DONT_HAVE_A_WEBSITE)}
          </Typography>
        )}
      </Box>
    </CardContainer>
  );
};

export default UrlSection;
